<div class="flex">
  <sbnb-subnav class="w-[280px] hidden md:block" [header]="'SETTINGS.SETTINGS' | transloco">
    <sbnb-settings-subnav></sbnb-settings-subnav>
  </sbnb-subnav>

  <main class="flex-1 subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <h2 class="flex items-center justify-between">Manage your subscription</h2>

    <p>You can't make changes to your plan or view our prices from the app. We know this isn't ideal.</p>

    <p>You can manage your existing subscription at hospitable.com in your web browser.</p>
  </main>
</div>

<sbnb-mobile-sidebar [title]="'Settings'">
  <sbnb-settings-subnav></sbnb-settings-subnav>
</sbnb-mobile-sidebar>
